/*
  View-only cart drawer.

  Opens from the header cart icon (intercepting the link, which still points at
  /cart so it degrades to a normal navigation without JS) and after an add to
  cart from a product or collection page.

  It shows lines, quantity controls, the subtotal and the free-delivery
  threshold — nothing else. There is deliberately NO checkout button and no
  delivery fields: the single primary action is "view cart & delivery details",
  which sends the customer to /cart where those are completed. This file never
  writes a cart attribute.
*/
(function () {
  var drawer = document.querySelector('[data-hub-drawer]');
  if (!drawer) return;

  var routes = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
  var moneyFormat = drawer.getAttribute('data-money-format') || '${{amount}}';
  var FREE = 12000; // $120 in cents — same threshold as the cart page
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var panel = drawer.querySelector('[data-hub-drawer-panel]');
  var body = drawer.querySelector('[data-hub-drawer-body]');
  var foot = drawer.querySelector('[data-hub-drawer-foot]');
  var totalEl = drawer.querySelector('[data-hub-drawer-total]');
  var shipEl = drawer.querySelector('[data-hub-drawer-ship]');

  var lastTrigger = null;
  var busy = false;

  function money(cents) {
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // keep the header count in step with changes made inside the drawer
  function setBubble(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      var span = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span');
      if (span) span.textContent = count;
    });
  }

  /* ---- rendering ---- */
  function lineHtml(item) {
    var img = item.image
      ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160_crop_center$1$2')) + '" alt="" loading="lazy">'
      : '<span class="hub-drawer__ph"></span>';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<span class="hub-drawer__variant">' + esc(item.variant_title) + '</span>' : '';
    return '<div class="hub-drawer__line" data-key="' + esc(item.key) + '">'
      + '<a class="hub-drawer__thumb" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>'
      + '<div class="hub-drawer__lmain">'
      + '<a class="hub-drawer__nm" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>'
      + variant
      + '<div class="hub-drawer__lrow">'
      + '<span class="hub-stepper">'
      + '<button type="button" class="hub-stepper__btn" data-drawer-dec aria-label="one fewer ' + esc(item.product_title) + '">−</button>'
      + '<span class="hub-stepper__n">' + item.quantity + '</span>'
      + '<button type="button" class="hub-stepper__btn hub-stepper__btn--plus" data-drawer-inc aria-label="one more ' + esc(item.product_title) + '">+</button>'
      + '</span>'
      + '<span class="hub-drawer__amt">' + money(item.final_line_price) + '</span>'
      + '</div>'
      + '<button type="button" class="hub-drawer__remove" data-drawer-remove aria-label="remove ' + esc(item.product_title) + '">remove</button>'
      + '</div>'
      + '</div>';
  }

  function render(cart) {
    setBubble(cart.item_count);
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p class="hub-small hub-drawer__empty">your cart is empty.</p>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(lineHtml).join('');
    foot.hidden = false;
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (shipEl) {
      // same wording and threshold as the cart page
      shipEl.textContent = cart.total_price >= FREE
        ? '✓ qualifies for free delivery'
        : 'add ' + money(FREE - cart.total_price) + ' more for free delivery — otherwise $10 flat delivery';
    }
  }

  function load() {
    return fetch(routes + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; })
      .catch(function () {
        body.innerHTML = '<p class="hub-small hub-drawer__empty">we couldn’t load your cart just now.</p>';
        foot.hidden = true;
      });
  }

  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    fetch(routes + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { busy = false; render(cart); })
      .catch(function () { busy = false; });
  }

  /* ---- focus trap ---- */
  function focusables() {
    return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE))
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) { e.preventDefault(); panel.focus(); return; }
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  /* ---- open / close ---- */
  function open(trigger) {
    lastTrigger = trigger || document.activeElement || null;
    drawer.hidden = false;
    // next frame so the transition runs from the off-screen state
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('hub-drawer-open');
    document.addEventListener('keydown', onKeydown);
    load().then(function () {
      var first = focusables()[0];
      (first || panel).focus();
    });
  }

  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('hub-drawer-open');
    document.removeEventListener('keydown', onKeydown);
    var done = function () { drawer.hidden = true; };
    // wait out the slide-out, but never strand the drawer open if no transition fires
    var t = setTimeout(done, 320);
    panel.addEventListener('transitionend', function once() {
      panel.removeEventListener('transitionend', once); clearTimeout(t); done();
    });
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }

  /* ---- wiring ---- */
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-hub-drawer-close]') || e.target.closest('[data-hub-drawer-overlay]')) {
      e.preventDefault(); close(); return;
    }
    var line = e.target.closest('.hub-drawer__line');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var qty = parseInt(line.querySelector('.hub-stepper__n').textContent, 10) || 0;
    if (e.target.closest('[data-drawer-inc]')) changeLine(key, qty + 1);
    else if (e.target.closest('[data-drawer-dec]')) changeLine(key, Math.max(0, qty - 1));
    else if (e.target.closest('[data-drawer-remove]')) changeLine(key, 0);
  });

  // header cart icon opens the drawer rather than navigating; the href stays
  // /cart so it still works with JS off or if this script fails to load
  document.addEventListener('click', function (e) {
    var icon = e.target.closest('#cart-icon-bubble');
    if (!icon) return;
    e.preventDefault();
    open(icon);
  });

  // add-to-cart from a product or collection page
  document.addEventListener('hub:cart:added', function (e) {
    open((e.detail && e.detail.trigger) || null);
  });

  window.HubCartDrawer = { open: open, close: close, refresh: load };
})();
